import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import DateField from '../../components/customFields/dateField';

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';

import GeneralForm from '../../components/generalForm';
import { connect } from 'react-redux';
import MultiSelect from '../../components/customFields/multiSelect';
import DeliveryDayTimeRanges from '../../components/customFields/deliveryDayTimeRanges';
import Helmet from 'react-helmet';

const DeliveryDayForm = ({ match, action, intl, history }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [serviceAreas, setServiceAreas] = useState([]);
  const [deliveryDay, setDeliveryDay] = useState({
    timeRanges: [
      {
        fromHour: '',
        fromMinutes: '',
        toHour: '',
        toMinutes: '',
        remaining: '',
      },
    ],
  });

  useEffect(() => {
    if (action === 'edit') {
      setError(null);
      setLoading(true);
      apiCalls
        .getDeliveryDays({
          deliveryDayId: match.params.deliveryDayId,
        })
        .then((result) => {
          setDeliveryDay(utils.getDeliveryDayForForm(result.data.deliveryDays[0]));
          setLoading(false);
          getServiceAreas();
        })
        .catch((errors) => {
          setError(utils.getErrorMessageFromResponse(errors));
          setLoading(false);
        });
    } else {
      getServiceAreas();
    }
  }, [match.params.deliveryDayId]);

  function getServiceAreas() {
    apiCalls
      .getServiceAreas({})
      .then((result) => {
        setServiceAreas(result.data.serviceAreas);
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
      });
  }

  const serviceAreaOptions = serviceAreas.map((serviceArea) => {
    return {
      value: serviceArea.id,
      label: `${serviceArea.name}`,
    };
  });

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      deliveryDate: {
        type: 'string',
        title: intl.formatMessage({ id: 'delivery.day.form.field.delivery.date.label' }),
      },
      serviceAreas: {
        type: 'string',
        options: serviceAreaOptions,
        title: intl.formatMessage({ id: 'delivery.day.form.field.service.areas.label' }),
      },
      refreshServiceAreaTimeRanges: {
        type: 'boolean',
        title: intl.formatMessage({ id: 'delivery.day.form.field.refresh.service.area.time.ranges.label' }),
      },
      isFruitVegDay: {
        type: 'boolean',
        title: intl.formatMessage({ id: 'delivery.day.form.field.is.fruit.veg.day.label' }),
      },
      sendOutReminderEmails: {
        type: 'boolean',
        title: intl.formatMessage({ id: 'delivery.day.form.field.send.out.reminder.emails.label' }),
      },
    },
  };

  if (action === 'edit') {
    formSchema.properties.timeRanges = {
      type: 'array',
    };
  }

  const uiSchema = {
    deliveryDate: {
      'ui:field': 'dateField',
    },
    refreshServiceAreaTimeRanges: {
      'ui:help': intl.formatMessage({ id: 'delivery.day.form.field.refresh.service.area.time.ranges.help' }),
    },
    serviceAreas: {
      'ui:field': 'multiSelect',
    },
    timeRanges: {
      'ui:field': 'deliveryDayTimeRanges',
    },
  };

  function onFormChange(event) {
    setDeliveryDay(event.formData);
  }

  function onFormSubmit() {
    setLoading(true);

    if (action === 'edit') {
      return apiCalls
        .editDeliveryDay({ deliveryDay })
        .then((result) => {
          setLoading(false);
          history.push({
            pathname: '/admin/deliveryDays',
          });
        })
        .catch((error) => {
          setLoading(false);
          setError(utils.getErrorMessageFromResponse(error, true));
          window.scrollTo(0, 0);
        });
    } else {
      return apiCalls
        .createDeliveryDay({ deliveryDay })
        .then((result) => {
          setLoading(false);
          history.push({
            pathname: '/admin/deliveryDays',
          });
        })
        .catch((error) => {
          setLoading(false);
          setError(utils.getErrorMessageFromResponse(error, true));
          window.scrollTo(0, 0);
        });
    }
  }

  const buttonCopy = action === 'edit' ? 'delivery.day.edit.form.submit' : 'delivery.day.create.form.submit';

  const formFields = {
    multiSelect: MultiSelect,
    dateField: DateField,
    deliveryDayTimeRanges: DeliveryDayTimeRanges,
  };

  const header =
    action === 'edit' && !loading
      ? intl.formatMessage({ id: 'delivery.day.edit.header' })
      : intl.formatMessage({ id: 'delivery.day.create.header' });

  return (
    <div className="row">
      <Helmet>
        <title>{header}</title>
      </Helmet>

      <div className="col-12 col-lg-10 offset-lg-1 admin__form">
        <GeneralForm
          title={header}
          onChange={onFormChange}
          onSubmit={onFormSubmit}
          formSchema={formSchema}
          formUiSchema={uiSchema}
          formFields={formFields}
          formData={deliveryDay}
          buttonCopy={buttonCopy}
          errorMessage={error}
          loading={loading}
          hideImageUpload={true}
        />
      </div>
    </div>
  );
};

DeliveryDayForm.propTypes = {
  currentUser: PropTypes.object,
  action: PropTypes.string.isRequired,
};

DeliveryDayForm.defaultProps = {
  action: 'create',
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(DeliveryDayForm));
